// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-news-feed-item-content .NewsFeedContent {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./Source/app/news-feed/news-feed-item-content/news-feed-item-content.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR","sourcesContent":[".fi-news-feed-item-content {\r\n    .NewsFeedContent {\r\n        font-size: 16px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
